import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { TimerComponent } from "@vendor/shared-component/timer/timer.component";

@Component({
  selector: 'app-otp-input',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.scss']
})
export class OtpInputComponent implements AfterViewInit {
  loginHelp: any = {
    name: 'otp',
    title: 'کد تایید یک بار مصرف',
    msg: 'برای انجام تراکنش در موبایل بانک اقتصاد نوین، کد تایید ارسالی به تلفن همراه خود را وارد نمایید.'
  };
  infoTitle = '';
  @Input() mobileNumber: string = '';
  @Input() isLoading: boolean = false;
  @Input() disabledResend: boolean = true;
  @Input() isEmailActive: boolean = false;
  @Input() isSmsActive: boolean = true;
  @Input() email: string = '';
  @Input() isFund: boolean = false;
  @Output() codeSubmitted: EventEmitter<string> = new EventEmitter<string>();
  @Output() resendRequested: EventEmitter<void> = new EventEmitter<void>();

  codeArray: string[] = ['', '', '', '', ''];
  @ViewChild(TimerComponent) timer: TimerComponent;

  ngAfterViewInit(): void {
    this.timer.startTimer(0,59);
    this.setInfoTitle()
  }
  onKeydown(event: KeyboardEvent) {
    const target = event.target as HTMLInputElement;
  if (event.key !== 'Backspace' && target.value.length === 1) {
    const nextInput = target.nextElementSibling as HTMLInputElement;
    if (nextInput && nextInput.value === '') {
      nextInput.focus();
    }
  }
    // this.emitCode();
  }

  backward(event: KeyboardEvent, index: number) {
    if (event.key === 'Backspace' && this.codeArray[index] === '') {
      const previousInput = (event.target as HTMLInputElement).previousElementSibling as HTMLInputElement;
      if (previousInput) {
        previousInput.focus();
      }
    }
  }

  setInfoTitle() {
    if (this.isFund) {
      this.infoTitle = 'به منظور تکمیل احراز هویت ، کد یک بار مصرف ارسال شده به شماره ثبت شده در سجام را وارد کنید.'
      return;
    }
    if (this.isEmailActive && this.isSmsActive) {
      this.infoTitle = 'کدی برای شما ارسال شده است. لطفا کد ارسال‌شده را وارد کنید'
    } else if (this.isSmsActive) {
      this.infoTitle = `کدی برای شماره موبایل ${this.mobileNumber} پیامک شده است. لطفا کد پیامک‌ شده را وارد کنید.`
    } else if (this.isEmailActive) {
      this.infoTitle = `کدی برای آدرس ایمیل ${this.email} ارسال شده است. لطفا کد ارسال‌شده را وارد کنید.`
    } else {
      this.infoTitle = 'کدی برای شما ارسال شده است. لطفا کد ارسال‌شده را وارد کنید'
    }
  }

  emitCode() {
    this.emitCodeIfComplete();
  }

  emitCodeIfComplete() {
    const code = this.codeArray.join('');
    if (code.length === 5) {
      const normalizeCode = this.convertToEnglishNumber(code)
      this.codeSubmitted.emit(normalizeCode);
    }
  }

  submitCode() {
    this.emitCodeIfComplete();
  }

  resendCode() {
    this.timer.startTimer(0,59)
    this.resendRequested.emit();
  }

  handlePaste(event: ClipboardEvent) {
    // Prevent the default paste behavior
    event.preventDefault();
  
    // Get the text from the clipboard
    const text = event.clipboardData?.getData('text/plain');
  
    // Check if the text is not null and has the correct length
    if (text && text.length === this.codeArray.length) {
      // Split the text into an array of single characters
      const characters = text.split('');
  
      // Assign each character to the corresponding input field
      this.codeArray = characters;
  
      // Emit the code if it's complete
      // this.emitCodeIfComplete();
    }
  }

  convertToEnglishNumber(value) {
    if (!value) {
      return;
    }
    const temp = [];
    let result = '';
    for (let i = 0; i < value.length; i++) {
      if (value.charCodeAt(i) > 1000) {
        const x = value.charCodeAt(i) - 1728;
        temp[i] = String.fromCharCode(x);
      } else {
        temp[i] = value[i];
      }
    }
    if (temp.length === value.length) {
      // tslint:disable-next-line: prefer-for-of
      for (let i = 0; i < temp.length; i++) {
        result += temp[i];
      }
    } else {
      result = value;
    }
    return result;
  }
}
